<template>
    <div>
        <app-table
			class="mt-3 is-not-selectable  no-main-list"
			:columns="columns"
			:filter-columns="false"
			:main-list="true"
			:rows="rows"
			icon-save
			:disabled-assign="disabledAssign"
			:index-by-row="indexByRow"
			:items-quantity="totalItemsVisible"
			:items-total-quantity="totalItems"
			:current-page="currentPage"
			:last-page="lastPage"
			@save-process="rowEmployee"
			@on-page="$emit('on-page', $event)"
			@on-search-event="$emit('on-search-event', $event)"
			@changeSort="$emit('changeSort', $event)"
			@changeColor="changeColor"
			title="Empleados Seleccionados">
				<template slot="rows" slot-scope="props">
					<td style="width: 20%;" v-show="showRow(columns, 1)">{{ props.row.employee.name }} {{ props.row.employee.lastName }}</td>
					<td v-show="showRow(columns, 2)">{{ props.row.employee.group.name }}</td>
					<td v-show="showRow(columns, 3)">{{ props.row.employee.phoneNumber }}</td>
					<td v-show="showRow(columns, 4)">{{ props.row.employee.email }}</td>
					<td v-show="showRow(columns, 5)">{{ numEvaluators(props.row.evaluators) }} </td>
					<td style="width: 15%;" v-show="showRow(columns, 6)">
					<!-- < style="width: 15%;" v-show="showRow(columns, 6)" @click.stop="stopClick"> -->
						<v-layout wrap>
							<app-tooltip-button
								img="/static/img/group-eval.svg"
								text="Evaluadores"
								@click-icon="chooseEvaluators(props.row, props.index)"
							/>
							<app-tooltip-button
								img="/static/img/close2.svg"
								text="Eliminar"
								@click-icon="$emit('click-icon', { action: 'delete', row: props.row })"
							/>
						</v-layout>
					</td>
				</template>
		</app-table>

    </div>
</template>

<script>
function mounted() {
}

function numEvaluators(numE) {
	if (Object.keys(numE).length === 0) {
		return 0;
	}
	return numE.employees.length;
}

function rowEmployee() {
	const newRowsEmployee = this.rows.map((row) => {
		const newRow = { ...row };
		delete newRow.additionalInformation;
		delete newRow.createdAt;
		delete newRow.deletedAt;
		delete newRow.employee;
		delete newRow.flagActive;
		delete newRow.id;
		delete newRow.process;
		return newRow;
	});
	this.$emit('save-process', newRowsEmployee);
}

function changeColor(fieldName) {
	this.columns.forEach((c, index) => {
		if (c.fieldName !== fieldName && c.color) {
			this.$set(this.columns, index, { ...c, color: 'gray' });
		}
	});
}

function chooseEvaluators(rowProp, indexProp) {
	this.indexByRow = indexProp;
	// this.rows[indexProp].isSelected = true;
	// this.$set(this.modifiRow[indexProp], 'isSelected', true);
	this.$emit('click-icon', { action: 'select', row: rowProp, index: indexProp });
}

function data() {
	return {
		indexByRow: null,
		columns: [
			{
				id: 1,
				name: 'Empleados',
				value: 'name',
				visible: true,
				checked: true,
				sortCheck: true,
				fieldName: 'employees',
				color: 'gray',
			},
			{
				id: 2,
				name: 'Área',
				value: 'group',
				visible: true,
				checked: true,
				sortCheck: true,
				fieldName: 'groups',
				color: 'gray',
			},
			{
				id: 3,
				name: 'Teléfono',
				value: 'phone',
				visible: true,
				checked: true,
			},
			{
				id: 4,
				name: 'Correo',
				value: 'mail',
				visible: true,
				checked: true,
			},
			{
				id: 5,
				name: 'Cant. Eva',
				value: 'evaluator',
				visible: true,
				checked: true,
			},
			{
				id: 6,
				name: 'ACCIONES',
				visible: true,
				checked: true,
			},
		],
	};
}

export default {
	name: 'process-list-employee-for-evaluation',
	data,
	mounted,
	components: {
	},
	methods: {
		numEvaluators,
		rowEmployee,
		chooseEvaluators,
		changeColor,
	},
	props: {
		rows: {
			default: () => [],
			type: Array,
		},
		disabledAssign: {
			type: Boolean,
			default: false,
		},
		currentPage: [Number, String],
		lastPage: [Number, String],
		totalItems: [Number, String],
		totalItemsVisible: [Number, String],
	},
};
</script>

<style lang="scss" scoped>
.icon {
	width: 2px;
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/process/process-list-employee-for-evaluation.vue